<div class="container">
    <db-tabs>
        <db-tab id="product" title="{{ 'header.tabbed.nav.product' | translate }}" icon="home-new"></db-tab>
        <db-tab id="personal-data" title="{{ 'header.tabbed.nav.personal-data' | translate }}" icon="legitimate"> </db-tab>
        <db-tab id="summary" title="{{ 'header.tabbed.nav.summary' | translate }}" icon="listview"> </db-tab>
        <db-tab id="completion" title="{{ 'header.tabbed.nav.completion' | translate }}" icon="check"> </db-tab>
    </db-tabs>
</div>